import React from "react";
import PropTypes from "prop-types";

import { InputSelectorSingle } from "./input_selector_single";
import { InputSelectorMultiple } from "./input_selector_multiple";

const InputSelector = ({
  selectionMode,
  options,
  selectedValues,
  disabledValues,
  onChange,
  collapseAtCount
}) => {
  const onChangeSelectorSingle = newValue => {
    onChange([newValue]); //convert to array from single value
  };

  const onChangeSelectorMultiple = newValues => {
    onChange(newValues);
  };

  switch (selectionMode.toLowerCase()) {
    case "single":
      let selectedValue =
        selectedValues && selectedValues.length > 0 ? selectedValues[0] : "";
      return (
        <InputSelectorSingle
          options={options}
          selectedValue={selectedValue}
          disabledValues={disabledValues}
          onChange={onChangeSelectorSingle}
        />
      );

    case "multiple":
      return (
        <InputSelectorMultiple
          options={options}
          selectedValues={selectedValues}
          disabledValues={disabledValues}
          onChange={onChangeSelectorMultiple}
          collapseAtCount={collapseAtCount ? collapseAtCount : 100}
        />
      );

    default:
      return <div>{selectionMode} selection mode not implemented</div>;
  }
};

InputSelector.propTypes = {
  selectionMode: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectedValues: PropTypes.array.isRequired,
  disabledValues: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  collapseAtCount: PropTypes.number
};

export default InputSelector;



// WEBPACK FOOTER //
// ./src/views/components/input_selector/InputSelector.jsx